export enum TransactionStatus {
  closed = 1,
  pmc = 2,
  entity = 3,
  open = 4,
}
